import { render, staticRenderFns } from "./ItemPopup.vue?vue&type=template&id=7c7190f2&scoped=true&lang=pug&"
import script from "./ItemPopup.vue?vue&type=script&lang=ts&"
export * from "./ItemPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ItemPopup.vue?vue&type=style&index=0&id=7c7190f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7190f2",
  null
  
)

export default component.exports